import { render, staticRenderFns } from "./Med.vue?vue&type=template&id=23f166ce&"
import script from "./Med.vue?vue&type=script&lang=ts&"
export * from "./Med.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports